import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    // Scroll to top when navigating to a new page
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    setIsMenuOpen(false);
  };

  const handleHomeNavigation = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <button onClick={handleHomeNavigation} className="w-12 h-12 flex items-center justify-center cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/501ecf28bb167b444bb1a5f14cdce300.png" 
                alt="Vine Consulting Engineers Logo" 
                className="w-12 h-12 object-contain"
              />
            </button>
            <button onClick={handleHomeNavigation} className="cursor-pointer text-left">
              <h1 className="text-xl font-bold text-gray-800">Vine Consulting Engineers</h1>
              <p className="text-sm" style={{ color: '#0B8D72' }}>Civil Engineering Consultants</p>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={handleHomeNavigation}
              className="text-gray-700 transition-colors cursor-pointer whitespace-nowrap hover:text-[#0B8D72]"
            >
              Home
            </button>
            <button 
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToSection('services'), 100);
              }}
              className="text-gray-700 transition-colors cursor-pointer whitespace-nowrap hover:text-[#0B8D72]"
            >
              Services
            </button>
            <button 
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToSection('about'), 100);
              }}
              className="text-gray-700 transition-colors cursor-pointer whitespace-nowrap hover:text-[#0B8D72]"
            >
              About Us
            </button>
            <button 
              onClick={() => handleNavigation('/team')}
              className="text-gray-700 transition-colors cursor-pointer whitespace-nowrap hover:text-[#0B8D72]"
            >
              Our Team
            </button>
            <button 
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToSection('projects'), 100);
              }}
              className="text-gray-700 transition-colors cursor-pointer whitespace-nowrap hover:text-[#0B8D72]"
            >
              Projects
            </button>
            <button 
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToSection('contact'), 100);
              }}
              className="text-white px-6 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap hover:bg-[#0A7A66]"
              style={{ backgroundColor: '#0B8D72' }}
            >
              Contact Us
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <div className="flex flex-col space-y-3 pt-4">
              <button 
                onClick={handleHomeNavigation}
                className="text-gray-700 transition-colors text-left cursor-pointer hover:text-[#0B8D72]"
              >
                Home
              </button>
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => scrollToSection('services'), 100);
                }}
                className="text-gray-700 transition-colors text-left cursor-pointer hover:text-[#0B8D72]"
              >
                Services
              </button>
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => scrollToSection('about'), 100);
                }}
                className="text-gray-700 transition-colors text-left cursor-pointer hover:text-[#0B8D72]"
              >
                About Us
              </button>
              <button 
                onClick={() => handleNavigation('/team')}
                className="text-gray-700 transition-colors text-left cursor-pointer hover:text-[#0B8D72]"
              >
                Our Team
              </button>
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => scrollToSection('projects'), 100);
                }}
                className="text-gray-700 transition-colors text-left cursor-pointer hover:text-[#0B8D72]"
              >
                Projects
              </button>
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => scrollToSection('contact'), 100);
                }}
                className="text-white px-6 py-2 rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap hover:bg-[#0A7A66]"
                style={{ backgroundColor: '#0B8D72' }}
              >
                Contact Us
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
